/* routeReducer
 *
 * The reducer merges route location changes into our immutable state.
 * The change is necessitated by moving to react-router-redux@5
 *
 */
import { Record } from 'immutable';
import { LOCATION_CHANGE } from 'react-router-redux';

// Initial routing state
const RouteStateRecord = Record({
  location: null,
});

/**
 * Merge route into the global application state
 */
const routing = (state = new RouteStateRecord({}), action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      return state.merge({
        location: action.payload,
      });
    default:
      return state;
  }
};

export default routing;
